<template>
    <div class="simple-dropdown" :class="{active: showingDropdownMenu}" :data-theme="theme">
        <div class="trigger" @click.stop="toggleDropdownMenu(!showingDropdownMenu)" ref="toggle"
             @mouseenter="onMouseEnterTrigger" @mouseleave="onMouseLeaveTrigger">
            <slot name="triggerButtonContent">
                <span class="dots"><i></i><i></i><i></i></span>
            </slot>
        </div>
        <div class="simple-dd-menu" ref="dropdownMenu" :data-theme="theme"
             :class="{show: showingDropdownMenu, 'has-arrow': dropdownArrow, 'animated': animated, repositioning: repositioning}"
             @click="clickDropdownMenuToHide && toggleDropdownMenu(false)"
             @mouseenter="onMouseEnterDropdownMenu"
             @mouseleave="onMouseLeaveDropdownMenu"
        >
            <div class="dropdown-arrow" v-if="dropdownArrow" ref="dropdownArrow"></div>
            <div class="dropdown-wrapper" ref="dropdownWrapper" :style="dropdownWrapperStyle">
                <i class="gf gf-close-hover close-button" v-if="dropdownCloseCorner"
                   @click="toggleDropdownMenu(false)"></i>
                <slot name="dropdownMenu"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    name: "SimpleDropdown",
    data() {
        return {
            showingDropdownMenu: false,
            listener1: null,
            listener2: null,
            listener3: null,
            dropdownMenuElem: null,
            dropdownMenuShowHandle: null,
            dropdownMenuHideHandle: null,
            repositioning: false,
        }
    },
    props: {
        clickDropdownMenuToHide: {
            default: true
        },
        dropdownArrow: {
            default: false
        },
        alignment: {
            default: 0
        },
        mouseEnterToShow: {
            default: false
        },
        dropdownMenuOffset: {
            default: 0
        },
        mouseEnterTimeout: {
            default: 200
        },
        mouseLeaveTimeout: {
            default: 200
        },
        dropdownWrapperStyle: {
            default: null
        },
        dropdownCloseCorner: {
            default: false,
        },
        dropdownOverflow: {
            default: 'auto',
        },
        theme: {
            type: String,
        },
        animated: {
            default: false,
        }
    },
    created() {
        this.listener1 = (event) => {
            const $target = $(event.target);
            if (this.showingDropdownMenu && $target.closest(this.$refs.toggle).length === 0 && $target.closest(this.dropdownMenuElem).length === 0) {
                this.toggleDropdownMenu(false);
            }
        };
        this.listener2 = () => {
            this.toggleDropdownMenu(false);
        };
        this.listener3 = (event) => {
            if (event.key === 'Escape') {
                this.toggleDropdownMenu(false);
            }
        };

        document.addEventListener('mousedown', this.listener1);
        window.addEventListener('blur', this.listener2);
        window.addEventListener('keydown', this.listener3);
    },
    mounted() {
        this.dropdownMenuElem = this.$refs.dropdownMenu;
        this.$nextTick(() => {
            document.body.appendChild(this.dropdownMenuElem);
        });
    },
    destroyed() {
        document.removeEventListener('mousedown', this.listener1);
        window.removeEventListener('blur', this.listener2);
        window.removeEventListener('keydown', this.listener3);
        $(this.dropdownMenuElem).remove();
    },
    methods: {
        onMouseLeaveTrigger() {
            if (!this.mouseEnterToShow) {
                return;
            }
            this.willHideLater();
        },
        onMouseEnterDropdownMenu() {
            if (!this.mouseEnterToShow) {
                return;
            }
            this.willShowLater();
        },
        onMouseLeaveDropdownMenu() {
            if (!this.mouseEnterToShow) {
                return;
            }
            this.willHideLater();
        },
        onMouseEnterTrigger() {
            if (!this.mouseEnterToShow) {
                return;
            }

            this.willShowLater();
        },
        willHideLater() {
            clearTimeout(this.dropdownMenuShowHandle);
            this.dropdownMenuShowHandle = null;

            if (this.showingDropdownMenu) {
                this.dropdownMenuHideHandle = setTimeout(() => {
                    this.toggleDropdownMenu(false);
                }, this.mouseLeaveTimeout);
            }
        },
        willShowLater() {
            clearTimeout(this.dropdownMenuHideHandle);
            this.dropdownMenuHideHandle = null;

            if (!this.showingDropdownMenu) {
                this.dropdownMenuShowHandle = setTimeout(() => {
                    this.toggleDropdownMenu(true);
                }, this.mouseEnterTimeout);
            }
        },
        toggleDropdownMenu(b) {
            if (this.showingDropdownMenu === b) {
                return;
            }
            this.showingDropdownMenu = b;
            if (b) {
                this.repositioning = true;
                setTimeout(() => {
                    this.reposition();
                    this.$emit('dropdownMenuShown');
                }, 0)
            } else {
                this.$emit('dropdownMenuHidden');
            }
        },
        reposition() {
            const relative = this.$refs.toggle.getBoundingClientRect();
            const targetElem = this.dropdownMenuElem;
            const targetBox = targetElem.getBoundingClientRect();

            const arrow = this.$refs.dropdownArrow;
            const wrapper = this.$refs.dropdownWrapper;
            const moreGap = 18;

            const windowHeight = window.innerHeight;
            const bottomSpace = windowHeight - relative.top - relative.height;
            let dropdownTop;
            let maxHeight;

            if (bottomSpace >= relative.top || bottomSpace >= targetBox.height + moreGap) {
                dropdownTop = relative.top + relative.height + this.dropdownMenuOffset;
                maxHeight = windowHeight - dropdownTop - moreGap;
            } else {
                dropdownTop = relative.top - targetBox.height + this.dropdownMenuOffset;
                if (dropdownTop < moreGap) {
                    dropdownTop = moreGap;
                }
                maxHeight = windowHeight - moreGap;
            }

            targetElem.style.top = `${dropdownTop}px`;
            wrapper.style.maxHeight = `${maxHeight}px`;
            wrapper.style.overflow = this.dropdownOverflow;

            if (this.alignment === 0) {
                // align to bottom left
                targetElem.style.left = `${relative.left}px`;

                if (arrow) {
                    arrow.style.left = `${relative.width / 2}px`;
                }
                this.repositioning = false;
            } else if (this.alignment === 1) {
                // align to bottom center
                this.$nextTick(() => {
                    const dropdownRect = targetElem.getBoundingClientRect();
                    let wrapperLeft = relative.left + relative.width / 2 - dropdownRect.width / 2;
                    let diff = wrapperLeft + dropdownRect.width + 8 - window.innerWidth;

                    if (diff > 0) {
                        wrapperLeft -= diff;
                    }

                    targetElem.style.left = `${wrapperLeft}px`;

                    if (arrow) {
                        arrow.style.left = `${relative.left + relative.width / 2 - wrapperLeft}px`;
                    }

                    this.repositioning = false;
                });
            } else {
                this.repositioning = false;
            }
        },
    },
    watch: {
        $route() {
            this.toggleDropdownMenu(false)
        }
    }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";

.simple-dropdown {
    position: relative;
    display: inline-flex;

    .trigger {
        display: inline-block;

        &:focus {
            box-shadow: 0 0 0 3px rgba($primary-blue, 0.6);
        }

        .dots {
            padding: 0;
            width: 1.1rem;
            height: 1.1rem;
            border-radius: 50%;
            background-color: #a0a0a0;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                width: 2px;
                height: 2px;
                background-color: white;
                border-radius: 50%;
                margin: 0 1px;
            }
        }

        &:hover {
            .dots {
                background-color: #777777;
            }
        }
    }

    &.active {
        .simple-dd-menu {
            display: block;
        }

        .trigger {
            .dots {
                background-color: #333333;
            }
        }
    }
}
</style>
<style lang="scss">
@import "../assets/variables";

.simple-dd-menu {
    position: absolute;
    z-index: 999;
    display: none;
    outline: none;

    &.show {
        display: block;
    }

    &.repositioning {
        visibility: hidden;
    }

    &.has-arrow {
        .dropdown-wrapper {
            margin-top: 8px;
            box-shadow: 0 1px 8px rgba(black, 0.2), 0 6px 32px rgba(black, 0.205);
        }
    }

    &.animated {
        animation: fadeInToTop 250ms ease-in;
    }

    ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .dropdown-arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-top: none;
        border-right: 8px solid transparent;
        border-bottom: 8px solid white;
        margin-top: 1px;
        margin-left: -8px;
        z-index: 1;
    }

    .dropdown-wrapper {
        background-color: white;
        box-shadow: 0 1px 8px rgba(black, 0.2), 0 4px 16px rgba(black, 0.05);
        /*min-width: 100px;*/
        padding: 0.32rem 0;
        margin-top: 2px;
        border-radius: 4px;
        display: inline-block;
        position: relative;

        &:hover {
            .close-button {
                opacity: 0.5;
            }
        }

        .close-button {
            position: absolute;
            right: 0.25rem;
            top: 0.5rem;
            line-height: 1.15rem;
            font-size: 0.875em;
            opacity: 0;

            &:hover {
                opacity: 1;
            }
        }

        li {
            padding: 2px 0.25rem;
            button, a {
                background-color: transparent;
                border: none;
                width: 100%;
                text-align: left;
                padding: 0.32rem 1.05rem;
                font-size: inherit;
                color: black;
                outline: none;
                white-space: nowrap;
                display: block;
                text-decoration: none;
                border-radius: 6px;

                &[disabled] {
                    color: gray;
                    cursor: not-allowed;
                }

                &:not([disabled]) {
                    &:hover {
                        background-color: rgba(black, 0.08);
                    }

                    &:focus {
                        box-shadow: 0 0 0 3px rgba($primary-blue, 0.6);
                    }
                }
            }

            &.separator {
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                margin: 0.25rem 0;
            }
        }
    }
}
</style>
